import { render, staticRenderFns } from "./SchedulesPage.vue?vue&type=template&id=61005d9a"
import script from "./SchedulesPage.vue?vue&type=script&lang=js"
export * from "./SchedulesPage.vue?vue&type=script&lang=js"
import style0 from "./SchedulesPage.vue?vue&type=style&index=0&id=61005d9a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61005d9a')) {
      api.createRecord('61005d9a', component.options)
    } else {
      api.reload('61005d9a', component.options)
    }
    module.hot.accept("./SchedulesPage.vue?vue&type=template&id=61005d9a", function () {
      api.rerender('61005d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/SchedulesPage.vue"
export default component.exports